import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {
  displayProfileModal,
  setProfileModalPage,
} from '../../../modules/profile/actions/creators'

import {
  setTransactionsEarned,
  setTransactionsRedeemed,
} from '../../../modules/loyalty/actions/creators'

import PointsHistoryPage from '../components/PointsHistoryPage/PointsHistoryPage'

const mapStateToProps = reduxState => {
  const { auth, profile, loyalty } = reduxState

  const { accessToken } = auth

  const { primaryInfo, showProfileModal, profileModalPage } = profile

  const { transactionsEarned, transactionsRedeemed } = loyalty

  return {
    accessToken,
    primaryInfo,
    showProfileModal,
    profileModalPage,
    transactionsEarned,
    transactionsRedeemed,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      displayProfileModal,
      setProfileModalPage,
      setTransactionsEarned,
      setTransactionsRedeemed,
    },
    dispatch,
  )

const ConnectedPointsHistoryPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PointsHistoryPage)

export default ConnectedPointsHistoryPage
